// extracted by mini-css-extract-plugin
export default {"container":"Instructions_container__GPw04","border":"Instructions_border__rdj6L","button":"Instructions_button__1GAqp"};